import { FC } from 'react';

import { useTranslations } from 'context/translations';
import {
  LandingPageImageKeys,
  LandingPageLinkKeys,
  LandingPageTextKeys,
} from 'service';
import { Button } from 'components';
import { useMediaQuery } from 'hooks';

import styles from './IntroContentBlock.module.css';

export const IntroContentBlock: FC = () => {
  const { t, image, link } = useTranslations();
  const isShadow = useMediaQuery('(max-width: 904px)');
  return (
    <div className={styles.container}>
      <div
        className={styles.background_container}
        style={{
          backgroundPosition: '0% 42%',
          backgroundSize: '900px',
          backgroundImage: `url(${image(
            LandingPageImageKeys.JoinBlockBackground,
            { h: 0 },
          )})`,
        }}
      />
      <div className={styles.person_container}>
        <img
          className={styles.person_image}
          alt="person"
          src={image(LandingPageImageKeys.IntroBlockPersonImage, { h: 1384 })}
        />
        {isShadow && <div className={styles.shadow} />}
      </div>
      <div className={styles.left}>
        <h1 className={styles.title}>
          {t(LandingPageTextKeys.IntroBlockTitle)}
        </h1>
        <div className={styles.description}>
          {t(LandingPageTextKeys.IntroBlockDescription)}
        </div>
        <div className={styles.control}>
          <Button
            to={link(LandingPageLinkKeys.AffiliatesLink)}
            size="large"
            view="black"
          >
            {t(LandingPageTextKeys.IntroBlockButton)}
          </Button>
        </div>
      </div>
    </div>
  );
};
